import { CaretLeftIcon } from '@phosphor-icons/react';
import { useQuery } from '@tanstack/react-query';
import { getGpts } from 'api/gpts';
import Button from 'components/Button';
import Container from 'components/Container';
import GptListItem from 'components/Gpts/GptListItem';
import Page from 'components/Layout/Page';
import React from 'react';
import { Link } from 'react-router-dom';

export default function List() {

    const { data: gpts, isLoading } = useQuery({
        queryKey: ['gpts'],
        queryFn: async () => await getGpts({}),
    });

    return (
        <>
            <Page isLoading={isLoading}>
                <Container>
                    <div className='flex gap-3 items-center pb-8 pt-20 md:pt-14'>
                        <div className='flex-1 flex items-center gap-3'>
                            <Link to={`/settings/`} className=''>
                                <CaretLeftIcon size={26} className='hover:text-muted' />
                            </Link>
                        </div>
                        <Link to="/settings/gpts/create"><Button>Crea nuovo GPT</Button></Link>
                    </div>

                    <div className=''>
                        <div className='border border-light rounded-sm mt-6'>
                            {gpts?.map(gpt => <GptListItem key={gpt._id} gpt={gpt} />)}
                        </div>
                    </div>
                </Container>
            </Page>
        </>
    )
}
